/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type StatusesPageEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const statusesPageEntryPoint: EntryPoint<StatusesPageEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<StatusesPageEntryPointComponent>(
			/* webpackChunkName: "async-insight-global-configuration-statuses-tab" */ './StatusesTabWithFG.tsx',
		),
		getPreloadProps: () => ({}),
	});
